import { forwardRef } from 'react';
import { cn } from '../../utils/shadcn';

export const FeaturedImage = forwardRef<
  HTMLImageElement,
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
    containerClassName?: string;
  }
>(({ alt, src, style, containerClassName, ...rest }, ref) => {
  const imgSrc = src || '/images/large-image-placeholder.png';
  return (
    <div
      className={cn(
        'aspect-w-16 border-y border-border aspect-h-9 rounded-none overflow-hidden flex items-center justify-center text-center',
        containerClassName,
      )}
      style={{ ...style }}
    >
      <img alt={alt} src={imgSrc} ref={ref} loading="lazy" className="object-cover" {...rest} />
    </div>
  );
});
